module.exports = "/lucky-balls/img/infobox/info_Box_010.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/infobox/info_Box_010.png
// module id = 1075
// module chunks = 0